// AXOR TECHNOLOGIES — global configuration & contact channels
export const WHATSAPP_NUMBER = "+17868272995";
export const WHATSAPP_DIGITS = "17868272995";
export const AXOR_EMAIL = "Axortechnologiesllc@gmail.com";
export const AXOR_PHONE = "+1 (786) 827-2995";
export const AXOR_PHONE_TEL = "+17868272995";
export const AXOR_ADDRESS = "7901 4TH ST N STE 300, ST PETERSBURG, FL 33702";
export const AXOR_ADDRESS_LINES = ["7901 4TH ST N STE 300", "ST PETERSBURG, FL 33702"];

export const WHATSAPP_MESSAGES = {
  general: "Hi Axor Technologies, I'd like to speak with your team.",
  student:
    "Hi Axor Technologies, I'm a student and I'd like to learn about career opportunities.",
  professional:
    "Hi Axor Technologies, I'm a professional looking to explore career opportunities.",
  greencard:
    "Hi Axor Technologies, I'm interested in exploring career opportunities aligned with my experience.",
  employer:
    "Hi Axor Technologies, I'd like to learn more about your recruitment services.",
};

// Build a WhatsApp deep link with a URL-encoded message.
export const waLink = (message = WHATSAPP_MESSAGES.general) =>
  `https://wa.me/${WHATSAPP_DIGITS}?text=${encodeURIComponent(message)}`;

export const jobApplyMessage = (title) =>
  `Hi Axor Technologies, I'm interested in applying for the ${title} opportunity.`;

export const mailtoLink = (subject = "", body = "") => {
  const params = [];
  if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
  if (body) params.push(`body=${encodeURIComponent(body)}`);
  return `mailto:${AXOR_EMAIL}${params.length ? "?" + params.join("&") : ""}`;
};

export const telLink = `tel:${AXOR_PHONE_TEL}`;
